module.exports = new __parcel__URL__("star_wolvez_game_logo_mobile.71809962.png").toString();